import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, get } from 'lodash';
import Notification from 'common-ui-components/dist/components/Atoms/Notification';
import Modal from 'common-ui-components/dist/components/Atoms/Modal';
import Button from 'common-ui-components/dist/components/Atoms/Button';
import Anchor from 'common-ui-components/dist/components/Atoms/Anchor';
import Input from 'common-ui-components/dist/components/Atoms/Input';
import { numberOnly, getUrlWithParams, getLabelWithComponent } from '../../../utils/utils';
import { QUOTE_HISTORY } from '../../../global/constants';

const AlreadyHaveQuoteModal = props => {
  const {
    showAlreadyQuote,
    setShowAlreadyQuote,
    labels,
    cartIconUrl,
    onSubmit,
    quoteErrorIconUrl,
    errorObj,
  } = props;

  const {
    dontKnowQuoteNo,
    viewQuoteHistory,
    enterQuoteNumber,
    continueToCheckout,
    cancel,
  } = labels;

  const modalHeading = () => <Notification title={labels.alreadyHaveAQuote} icon={cartIconUrl} />;
  const [inputValue, setInputValue] = useState();
  const [quoteError, setQuoteError] = useState();

  const handleOnChange = e => {
    const quote = numberOnly(e);
    setInputValue(quote);
  };

  const quoteHistoryLink = (
    <Anchor
      to={getUrlWithParams(QUOTE_HISTORY)}
      className="go-to-quote-history-link"
      role="link"
      elementLocator="go-to-link-quote-history"
    >
      {viewQuoteHistory}
    </Anchor>
  );

  useEffect(() => {
    setInputValue();
    setQuoteError();
  }, [showAlreadyQuote]);

  useEffect(() => {
    let quoteErrorStr = '';
    if (!isEmpty(errorObj)) {
      const code = get(errorObj, ['error', 'code'], '');
      quoteErrorStr = getLabelWithComponent(labels[code], [quoteHistoryLink]);
    }
    setQuoteError(quoteErrorStr);
  }, [errorObj]);
  const modalProps = {
    className: 'modal__Content already-have-quote-modal',
    shouldCloseOnOverlayClick: true,
    isOpen: showAlreadyQuote,
    onRequestClose: () => setShowAlreadyQuote(false),
    heading: modalHeading(),
  };
  return (
    <Modal {...modalProps}>
      <>
        {!quoteError && (
          <div>
            {dontKnowQuoteNo}
            {quoteHistoryLink}
          </div>
        )}

        {quoteError && (
          <div className="error-msg">
            <Notification
              variation="inline"
              type="error"
              description={quoteError}
              icon={quoteErrorIconUrl}
              className="col-xs-12"
              elementLocator="notification-inline-error"
            />
          </div>
        )}
        <div className="quote-number-label">{enterQuoteNumber}</div>
        <div className="quote-id-input-control">
          <Input
            id="code"
            type="text"
            name="quoteNumber"
            maxInputLength="10"
            placeholder=""
            value={inputValue}
            className="quote-number"
            {...{
              onChange: e => {
                handleOnChange(e);
              },
            }}
            elementLocator="input-quote-number-id"
          />
        </div>
        <div className="center-xs">
          <Button
            className="primary already-quote-submit-button"
            {...{ onClick: () => inputValue && onSubmit(inputValue.trim()) }}
            elementLocator="button-quick-order-add-to-cart"
          >
            {continueToCheckout}
          </Button>

          <Anchor
            to="#"
            className="already-quote-cancel-link"
            elementLocator="link-already-quote-cancel"
            {...{ onClick: () => setShowAlreadyQuote(false) }}
          >
            {cancel}
          </Anchor>
        </div>
      </>
    </Modal>
  );
};

AlreadyHaveQuoteModal.propTypes = {
  showAlreadyQuote: PropTypes.bool,
  setShowAlreadyQuote: PropTypes.func,
  labels: PropTypes.shape({
    alreadyHaveAQuote: PropTypes.string,
    dontKnowQuoteNo: PropTypes.string,
    viewQuoteHistory: PropTypes.string,
    enterQuoteNumber: PropTypes.string,
    continueToCheckout: PropTypes.string,
    cancel: PropTypes.string,
  }),
  cartIconUrl: PropTypes.string,
  onSubmit: PropTypes.func,
  errorObj: PropTypes.shape({ error: PropTypes.string }),
  quoteErrorIconUrl: PropTypes.string,
};

AlreadyHaveQuoteModal.defaultProps = {
  showAlreadyQuote: false,
  setShowAlreadyQuote: () => {
    /* default setShowAlreadyQuote handler */
  },
  labels: {},
  cartIconUrl: '',
  onSubmit: () => {
    /* default onSubmit handler */
  },
  errorObj: {},
  quoteErrorIconUrl: '',
};

export default AlreadyHaveQuoteModal;
